var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 23.79L19.89 29.25C19.5 29.64 19.045 29.835 18.525 29.835C18.005 29.835 17.55 29.64 17.16 29.25L0.585 12.675C0.195 12.285 0 11.8462 0 11.3588C0 10.8713 0.195 10.4325 0.585 10.0425L6.045 4.5825C6.435 4.1925 6.90625 3.9975 7.45875 3.9975C8.01125 3.9975 8.4825 4.1925 8.8725 4.5825L25.35 21.06C25.74 21.45 25.935 21.905 25.935 22.425C25.935 22.945 25.74 23.4 25.35 23.79ZM18.525 25.155L21.255 22.425L7.41 8.58L4.68 11.31L18.525 25.155ZM32.37 39L24.0825 30.7125L26.8125 27.9825L35.1 36.27L32.37 39ZM32.175 13.65C30.29 13.65 28.6812 12.9838 27.3487 11.6512C26.0163 10.3188 25.35 8.71 25.35 6.825C25.35 4.94 26.0163 3.33125 27.3487 1.99875C28.6812 0.66625 30.29 0 32.175 0C34.06 0 35.6688 0.66625 37.0013 1.99875C38.3338 3.33125 39 4.94 39 6.825C39 8.71 38.3338 10.3188 37.0013 11.6512C35.6688 12.9838 34.06 13.65 32.175 13.65ZM32.175 9.75C32.9875 9.75 33.6781 9.46562 34.2469 8.89688C34.8156 8.32812 35.1 7.6375 35.1 6.825C35.1 6.0125 34.8156 5.32188 34.2469 4.75313C33.6781 4.18438 32.9875 3.9 32.175 3.9C31.3625 3.9 30.6719 4.18438 30.1031 4.75313C29.5344 5.32188 29.25 6.0125 29.25 6.825C29.25 7.6375 29.5344 8.32812 30.1031 8.89688C30.6719 9.46562 31.3625 9.75 32.175 9.75Z",
    fill: "#FF923E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnings);
export default __webpack_public_path__ + "static/media/Innings.8888d752c537e4d97c4b2a90a04898d5.svg";
export { ForwardRef as ReactComponent };